import { gql } from '@apollo/client';

/**
 * 研发工具短信工具：单次 Excel 批量导入行数上限。
 * 后端从配置中心 sms_tool.batch.max_rows 读取（走 Redis 缓存），未配置或非法时回落 200。
 * 放后端 + 配置中心是为了在线调整上限而无需前端发版。
 */
export const SMS_TOOL_BATCH_MAX_ROWS = gql`
  query SmsToolBatchMaxRows {
    smsToolBatchMaxRows
  }
`;

export interface SmsToolBatchMaxRowsResult {
  smsToolBatchMaxRows: number;
}
